import { Outlet, RouteObject } from "react-router-dom";

import ApplicationsApply from "@/features/applications/pages/applications-apply";
import LicenceApplicationForm from "./pages/form/licence-application-form";
import InvestmentApplicationForm from "./pages/form/investment-application-form";
import InvestmentsApplications from "./pages/fragments/investments/investments-applications";
import LicencesApplications from "./pages/fragments/licences/licences-applications";
import ApplicationLicenceDetails from "./pages/fragments/licences/application-licence-details";
import ApplicationInvestmentDetails from "./pages/fragments/investments/application-investment-details";
import ApplicationsLayout from "./application-layout";
import LicenceApplicationEdit from "./pages/edit/licence-application-edit";
import InvestmentApplicationEdit from "./pages/edit/investment-application-edit";
import { InvestmentDetailWithEdit, LicenceDetailWithEdit } from "./pages/edit/application-edit-action";



const routes: RouteObject = {
    path: "applications",
    element: <Outlet />,
    children: [
        {
            path: "",
            element: <ApplicationsLayout />,
            children: [
                {
                    index: true,
                    path: "licences",
                    element: <LicencesApplications />,
                },
                {
                    path: "investments",
                    element: <InvestmentsApplications />,
                },
            ]
        },
        {
            path: "apply",
            element: <ApplicationsApply />,
        },
        {
            path: "licence",
            element: <LicenceApplicationForm />,
        },

        {
            path: "investment",
            element: <InvestmentApplicationForm />,
        },
        {
            // The detail page is nested under a wrapper that adds the "Edit
            // application" action above it, so the detail fragment itself stays
            // as it is.
            path: "licences/applications-details/:applicationId",
            element: <LicenceDetailWithEdit />,
            children: [
                {
                    index: true,
                    element: <ApplicationLicenceDetails />,
                },
            ],
        },
        {
            path: "licences/applications-details/:applicationId/edit",
            element: <LicenceApplicationEdit />,
        },
        {
            path: "investments/applications-details/:applicationId",
            element: <InvestmentDetailWithEdit />,
            children: [
                {
                    index: true,
                    element: <ApplicationInvestmentDetails />,
                },
            ],
        },
        {
            path: "investments/applications-details/:applicationId/edit",
            element: <InvestmentApplicationEdit />,
        },
    ]
}

export default routes